import React from 'react'
import { FormPassword } from './form-password'

const ContentPassword = () => {
  return (
    <div className="w-full">
      <p className="text-lg font-bold mb-5 lg:mb-8">Your Password</p>
      <div style={{maxWidth: '541px'}}>
        <FormPassword />
      </div>
    </div>
  )
}

export { ContentPassword }